module.exports = __webpack_public_path__ + "Tinebase/js/ace-csound_score-FAT.js";